(function ($) {
    'use strict';

    $(document).ready(function () {
        // console.log('Hero JS: Document ready');
        const $playBtn = $('#videoPlayBtn');
        const $modal = $('#videoModal');
        const $closeBtn = $('.close-modal');
        const $overlay = $('.modal-overlay');
        const $iframe = $('#videoIframe');

        /* console.log('Hero JS: Elements found:', {
            playBtn: $playBtn.length,
            modal: $modal.length,
            closeBtn: $closeBtn.length,
            overlay: $overlay.length,
            iframe: $iframe.length
        }); */

        if ($playBtn.length && $modal.length) {
            $playBtn.on('click', function (e) {
                // console.log('Hero JS: Play button clicked');
                e.preventDefault();
                const videoUrl = $(this).attr('href');
                // console.log('Hero JS: Video URL:', videoUrl);

                // Extract video ID from youtube URL
                const match = videoUrl.match(/(?:https?:\/\/(?:www\.)?youtube\.com\/watch\?v=)|(?:https?:\/\/youtu\.be\/)([a-zA-Z0-9_-]{11})/);
                const videoId = match ? match[1] : null;
                // console.log('Hero JS: Video ID:', videoId);

                if (videoId) {
                    $iframe.attr('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`);
                    $modal.addClass('active');
                    $('body').css('overflow', 'hidden');
                    // console.log('Hero JS: Modal activated');
                }
            });

            const closeModal = function () {
                // console.log('Hero JS: Closing modal');
                $modal.removeClass('active');
                $iframe.attr('src', '');
                $('body').css('overflow', '');
            };

            $closeBtn.on('click', closeModal);
            $overlay.on('click', closeModal);

            $(document).on('keydown', function (e) {
                if (e.key === 'Escape' && $modal.hasClass('active')) {
                    closeModal();
                }
            });
        }
    });

})(jQuery);
